import Vue from 'vue'
import Vuex from 'vuex'


import groupsModule from './modules/groups';
import usersModule from './modules/users';
import autentificationModule from './modules/authentication';
import packetItemsModule from './modules/packetItems';
import packetsModule from './modules/packets';
import companiesModule from './modules/companies';
import pusherDataModule from './modules/pusherData';
import recorderModule from './modules/recorder';
import transcriptionsModule from './modules/transcriptions';
import uploadsModule from './modules/uploads';
import servicesModule from './modules/services';
import summariesModule from './modules/summaries';
import articlesModule from './modules/articles';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    groups: groupsModule,
    users: usersModule,
    authentication: autentificationModule,
    packetItems: packetItemsModule,
    packets: packetsModule,
    companies: companiesModule,
    pusherData: pusherDataModule,
    recorder: recorderModule,
    transcriptions: transcriptionsModule,
    uploads: uploadsModule,
    services: servicesModule,
    summaries: summariesModule,
    articles: articlesModule,
  },
});